module.exports = __webpack_public_path__ + "img/labs2.91cf59f7.svg";